"use client";

import { ButtonHTMLAttributes } from "react";
import { useAuth } from "@/contexts/authContext";

type LogoutButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export default function LogoutButton(props: LogoutButtonProps) {
  const { logout } = useAuth();

  const handleLogout = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    await logout();
    // Any additional logic can be added here if needed
    if (props.onClick) {
      props.onClick(event);
    }
  };

  return (
    <button {...props} type="button" onClick={handleLogout}>
      {props.children ?? "Log out"}
    </button>
  );
}
